import { Directive, ElementRef, AfterContentChecked } from '@angular/core';

@Directive({
  selector: '[textareaAutoheight]'
})
export class TextareaAutoheightDirective implements AfterContentChecked {

  constructor(private element: ElementRef) {
    this.resize();
  }

  ngAfterContentChecked() {
    this.resize();
  }

  resize() {
    if(!this.element)
      return;
    this.element.nativeElement.style.height = 0;
    this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + 'px';
  }
}